export default __webpack_public_path__ + "static/media/Icon-zoomin.6dffe6b0.svg";